import {
  GET_USERS_SUCCESS,
  GET_CUSTOMERS_SUCCESS,
  GET_SITES_SUCCESS,
  GET_DEVICES_SUCCESS,
  GET_CAMERAS_SUCCESS,
  GET_VIEWS_SUCCESS,
  UPDATE_USERS,
  UPDATE_CUSTOMERS,
  UPDATE_SITES,
  UPDATE_DEVICES,
  UPDATE_CAMERAS,
  UPDATE_VIEWS,
} from '../actions/types';

const INITIAL_STATE = {
  customers: [],    // list of all customers
  sites: [],        // list of all sites
  devices: [],      // list of all devices
  cameras: [],      // list of all cameras
  views: [],        // list of all views
  users: [],        // list of all users
};

// eslint-disable-next-line
export default ( state = INITIAL_STATE, action ) => {
  switch ( action.type ) {
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
      }
    case GET_SITES_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        sites: action.payload.projects,
      }
    case GET_DEVICES_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        sites: action.payload.projects,
        devices: action.payload.devices,
      }
    case GET_CAMERAS_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        sites: action.payload.projects,
        devices: action.payload.devices,
        cameras: action.payload.cameras,
      }
    case GET_VIEWS_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        sites: action.payload.projects,
        devices: action.payload.devices,
        cameras: action.payload.cameras,
        views: action.payload.views,
      }
    case GET_USERS_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        sites: action.payload.projects,
        devices: action.payload.devices,
        cameras: action.payload.cameras,
        views: action.payload.views,
        users: action.payload.users,
      }
    case UPDATE_USERS:
      return {
        ...state,
        users: action.payload
      }
    case UPDATE_CUSTOMERS:
      return {
        ...state,
        customers: action.payload
      }
    case UPDATE_SITES:
      return {
        ...state,
        sites: action.payload
      }
    case UPDATE_DEVICES:
      return {
        ...state,
        devices: action.payload
      }
    case UPDATE_CAMERAS:
      return {
        ...state,
        cameras: action.payload
      }
    case UPDATE_VIEWS:
      return {
        ...state,
        views: action.payload
      }
    default:
      return state;
  };
};